export default "__VITE_PUBLIC_ASSET__eebe4a8f__"